import styled from 'styled-components';

export const EbmProposalsCell = styled.div.attrs({
  className: 'flex items-center gap-2 shrink-0',
})``;

export const EbmProposalsRow = styled.div.attrs({
  className: 'flex items-center justify-between gap-2',
})``;
